import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
import { catchError } from 'rxjs/operators';
import { HandleError, HttpErrorHandlerService } from '../http-error-handler.service';

import { GatePass } from '../../model/Security/GatePass';
import { environment } from 'src/environments/environment';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';

@Injectable({
  providedIn: 'root'
})
export class GatePassService {
  private handleError: HandleError;
  constructor(
    private http: HttpClient,
    private apiFactory: APIFactoryEndPoints,
    httpErrorHandler: HttpErrorHandlerService
  ) {
    this.handleError = httpErrorHandler.createHandleError('GatePassAPIService');
  }
  createGatePass(gatePass: GatePass): Observable<any> {
    Object.getOwnPropertyNames(gatePass).forEach(key => {
      //alert(key+"="+gatePass.visitor_ref_no);
    });
   
    return this.http.post(this.apiFactory.serverNewUrl,
      gatePass,
      { responseType: 'json' })
      .pipe(
        catchError(this.handleError('createGatePass()', gatePass))
      );
  }
  editGatePass(editGatePass: GatePass): Observable<any> {
    Object.getOwnPropertyNames(editGatePass).forEach(key => {
    });
      return this.http.post(this.apiFactory.serverNewUrl,
        editGatePass,
        { responseType: 'json' })
        .pipe(
          catchError(this.handleError('editGatePass()', editGatePass))
        );
  }
}
